"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiStoresUrlSlugProductsReorderPatchRequestToJSON = exports.ApiStoresUrlSlugProductsReorderPatchRequestFromJSONTyped = exports.ApiStoresUrlSlugProductsReorderPatchRequestFromJSON = exports.instanceOfApiStoresUrlSlugProductsReorderPatchRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ApiStoresUrlSlugProductsReorderPatchRequest interface.
 */
function instanceOfApiStoresUrlSlugProductsReorderPatchRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfApiStoresUrlSlugProductsReorderPatchRequest = instanceOfApiStoresUrlSlugProductsReorderPatchRequest;
function ApiStoresUrlSlugProductsReorderPatchRequestFromJSON(json) {
    return ApiStoresUrlSlugProductsReorderPatchRequestFromJSONTyped(json, false);
}
exports.ApiStoresUrlSlugProductsReorderPatchRequestFromJSON = ApiStoresUrlSlugProductsReorderPatchRequestFromJSON;
function ApiStoresUrlSlugProductsReorderPatchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'productIds': !(0, runtime_1.exists)(json, 'product_ids') ? undefined : json['product_ids'],
    };
}
exports.ApiStoresUrlSlugProductsReorderPatchRequestFromJSONTyped = ApiStoresUrlSlugProductsReorderPatchRequestFromJSONTyped;
function ApiStoresUrlSlugProductsReorderPatchRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'product_ids': value.productIds,
    };
}
exports.ApiStoresUrlSlugProductsReorderPatchRequestToJSON = ApiStoresUrlSlugProductsReorderPatchRequestToJSON;
